import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog
} from "@material-ui/core"
import LoadingButton from "../../components/LoadingButton"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import {
  toggleSuggestPositionDialog,
  suggestRole
} from "../../actions/companies"
import InputLabel from "@material-ui/core/InputLabel"
import Input from "@material-ui/core/Input"
import FormControl from "@material-ui/core/FormControl"
import { openSnackBar } from "../../actions/snack-bar"

const defaultState = {
  suggestion: "",
  saving: false
}
class SuggestPositionDialog extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState
  }

  handleClose = () => {
    this.props.dispatch(toggleSuggestPositionDialog())
    this.setState(defaultState)
  }
  clearState = () => {
    this.setState(defaultState)
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    this.setState({ [fieldName]: value })
  }

  submit = e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({ saving: true })
    this.props
      .dispatch(suggestRole({ name: this.state.suggestion }))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Position Suggested"
          })
        )
        this.handleClose()
      })
      .catch(err => {
        this.setState({ saving: false })
        this.props.dispatch(
          openSnackBar({
            message: "There was an error suggesting your Position"
          })
        )
      })
  }
  render() {
    const { fullScreen, classes } = this.props
    const { suggestion } = this.state
    return (
      <Fragment>
        <Dialog
          className={classes.bookingDialog}
          fullScreen={fullScreen}
          open={this.props.open}
          onClose={this.handleClose}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper
            }
          }}
        >
          <form onSubmit={this.submit} autoComplete="off">
            <DialogContent className={classes.dialogContent}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Typography>
                    Please add your suggestion and our team will review it
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="suggestion">
                      Position Suggestion
                    </InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      name="suggestion"
                      value={suggestion}
                      onChange={this.handleInputChange}
                      id="suggestion"
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions
              className={classes.dialogActions}
              classes={{
                action: classes.dialogActionsAction
              }}
            >
              <Button color="primary" onClick={this.handleClose} type="button">
                Close
              </Button>
              <LoadingButton
                color="secondary"
                buttonclicked={this.submit}
                working={this.state.saving}
                type="button"
              >
                Submit
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.companies.suggestPositionDialogOpen
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(SuggestPositionDialog)
